/**
 * DenSalesArsenalSection — shared Sales Arsenal link block (NAV Polish v2,
 * 2026-05-11). Sales Arsenal lives in /dashboard/sales-arsenal; this card
 * is appended to each Den render so users can find it after Sales Arsenal
 * was removed from main NAV.
 *
 * Each Den just links — never duplicates the Arsenal UI here.
 *
 * @version v0.1
 */
import { Swords } from "lucide-react";

interface Props {
  /** Optional persona slug for analytics / foxchat-id. */
  persona?: string;
}

export function DenSalesArsenalSection({ persona }: Props) {
  return (
    <section
      className="mt-6"
      data-foxchat-id={persona ? `den-sales-arsenal-${persona}` : "den-sales-arsenal"}
    >
      <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Sales Arsenal</h2>
      <a
        href="/dashboard/sales-arsenal"
        className="flex items-center gap-3 rounded-xl border border-border bg-card hover:border-primary/40 transition-colors p-4"
      >
        <div className="rounded-lg p-2 bg-primary/10 border border-primary/30">
          <Swords className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold">Open Sales Arsenal</div>
          <p className="text-xs text-muted-foreground mt-0.5">Battle cards, objection sheets, competitor comparison cards. One tool, shared across every Den.</p>
        </div>
        <span className="text-xs text-primary">Open →</span>
      </a>
    </section>
  );
}
